import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomeOne from './HomeOne'
import About from './About'
import LoadTop from '../Components/LoadTop'
import Destination from './Destination'
import DestinationDetails from './DestinationDetails'
import Service from './Service'
import ServiceDetails from './ServiceDetails';
import Gallery from './Gallery'
import Tour from './Tour'
import TourDetails from './TourDetails'
import Faq from './Faq'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import Contact from './Contact'
function RouterPage() {
  return (
    <div>
      <Router>
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeOne />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/destinations" element={<Destination />}></Route>
          <Route path="/destinations/:slug" element={<DestinationDetails />} />
          {/* <Route path="/service" element={<Service />}></Route>
          <Route path="/service/:id" element={<ServiceDetails />} /> */}
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/tours" element={<Tour />}></Route>
          <Route path="/tours/:slug" element={<TourDetails />}></Route>
          <Route path="/faq" element={<Faq />}></Route>
          <Route path="/blogs" element={<Blog />}></Route>
          <Route path="/blogs/:slug" element={<BlogDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route> 
        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage